import { addWeeks, getISOWeek, startOfISOWeek } from "date-fns";

// 해당 week의 월요일 구하기
export const getDateFromISOYearWeek = (year: number, week: number) => {
  // 해당 연도 첫번째 주 월요일 구하기
  const firstISOWeekMonday = startOfISOWeek(new Date(year, 0, 4));
  // 현재 주의 월요일
  return addWeeks(firstISOWeekMonday, week - 1);
};

export const getWeekOfMonth = (year: number, week: number) => {
  const date = getDateFromISOYearWeek(year, week);
  const month = date.getMonth() + 1;

  const displayYear = week === 1 ? year - 1 : date.getFullYear();

  // 해당 월의 첫 날의 ISO week
  const startWeekOfMonth = getISOWeek(
    new Date(date.getFullYear(), date.getMonth(), 7)
  );
  // 현재 ISO week - 시작 ISO week = 해당 월의 몇 번째 주
  let weekInMonth = week + 1 - startWeekOfMonth;

  // 해당 연도의 마지막 주 값 보정
  if (weekInMonth < 0) {
    const lastWeek = getISOWeek(new Date(year - 1, 11, 28));
    weekInMonth = lastWeek + 2 - startWeekOfMonth;
  }

  return { displayYear, month, weekInMonth };
};

export const getISOWeekYearAndWeek = (date: Date) => {
  const d = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );

  // 목요일 기준으로 weekYear 결정
  const dayNum = d.getUTCDay() || 7; // 일요일=7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);

  const weekYear = d.getUTCFullYear();

  // week 계산
  const yearStart = new Date(Date.UTC(weekYear, 0, 1));
  const week = Math.ceil(((+d - +yearStart) / 86400000 + 1) / 7);

  return { weekYear, week };
};
